import React from 'react'
import { Play, Pause, StopCircle } from 'lucide-react'

interface FloatingAudioControlProps {
  isPlaying: boolean
  isPaused: boolean
  onPlayPause: () => void
  onStop: () => void
}

export default function FloatingAudioControl({
  isPlaying,
  isPaused,
  onPlayPause,
  onStop,
}: FloatingAudioControlProps) {
  if (!isPlaying && !isPaused) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        background: 'var(--navy)',
        border: '1px solid rgba(255,255,255,.2)',
        borderRadius: 999,
        padding: '10px 16px',
        boxShadow: 'var(--sh-lg)',
      }}
    >
      <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--white)' }}>
        {isPaused ? 'Audio Paused' : 'Playing Audio...'}
      </span>
      <button
        type="button"
        onClick={onPlayPause}
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: 'rgba(255,255,255,.15)',
          border: 'none',
          color: 'var(--white)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        title={isPaused ? 'Resume' : 'Pause'}
      >
        {isPaused ? <Play size={14} /> : <Pause size={14} />}
      </button>
      <button
        type="button"
        onClick={onStop}
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: 'rgba(255,255,255,.1)',
          border: 'none',
          color: 'var(--white)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        title="Stop"
      >
        <StopCircle size={14} />
      </button>
    </div>
  )
}
